import React from 'react';
import AnnotationToolBar from './AnnotationToolBar';
import {ControlButton, Glyphs, TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import withMemoizedContexts from '../../context/contextContainerHoC';
import {quizDataStore} from '../../context/quizDataProvider';

const CommentControls = styled.div`
   display: flex;
   justify-content: flex-end;
   padding-bottom: .25rem;

   button {
      margin-left: 0.5rem;
   }
`;

const SubmitButtonWrapper = styled.div`
   button {
      padding: 0 0.5rem;
   }
`;

export const CommentSubmitBase: React.FC<ICommentSubmitProps & IStateMappedProps> = ({isDisabled, isReply, setAnnotationExists, onSubmit, IsQuizzing}) => {
   const {t} = useTranslation();

   return (
      <CommentControls>
         {!isReply && !IsQuizzing && <AnnotationToolBar setAnnotationExists={setAnnotationExists} />}
         <SubmitButtonWrapper>
            <ControlButton
               testId="submit-comment-button"
               buttonType={TscButtonType.primary}
               title={t('general.send')}
               onClick={onSubmit}
               disabled={isDisabled}
               glyph={<Glyphs.Send16x16 />}
            />
         </SubmitButtonWrapper>
      </CommentControls>
   );
};

export interface ICommentSubmitProps {
   isDisabled: boolean;
   isReply: boolean;
   setAnnotationExists(annotationExists: boolean): void;
   onSubmit(): void;
}

export interface IStateMappedProps {
   IsQuizzing: boolean;
}

const mapStatesToProps = (
   {isDisabled, isReply, setAnnotationExists, onSubmit}: ICommentSubmitProps,
   {IsQuizzing}: Partial<IStateMappedProps>
): ICommentSubmitProps & IStateMappedProps => ({isDisabled, isReply, setAnnotationExists, onSubmit, IsQuizzing});

export default withMemoizedContexts(mapStatesToProps, quizDataStore)(CommentSubmitBase);
